import React from 'react'
import 'moment/locale/pt-br' // without this line it didn't work
import decodeEntities from '../../util/textDecode'
import Container from './styles'

const ThumbList = ({ items }) => {
  return (
    <Container>
      <ul className="materiais">
        {items.map((item, index) => (
          <li key={index}>
            <a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              className="thumb"
            >
              <img
                src={
                  item.imagemDestaque !== null
                    ? item.imagemDestaque.sourceUrl
                    : 'https://via.placeholder.com/370x214.png?text=Sem%20imagem'
                }
                alt="Curso"
              />
            </a>
            <small>{item.data}</small>
            <h3>
              <a href={item.url} target="_blank" rel="noreferrer">
                {decodeEntities(item.titulo)}
              </a>
            </h3>
            <p
              dangerouslySetInnerHTML={{
                __html: item.descricao.replace(/<p class="link-more.*/, ''),
              }}
            />
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default ThumbList
